import { z } from 'zod'

export const apiEnvelope = <T extends z.ZodType>(data: T) => z.object({
  code: z.string().optional(),
  message: z.string().optional(),
  requestId: z.string().optional(),
  data,
})

export const emptyEnvelopeSchema = apiEnvelope(z.unknown().nullish())

export const pageSchema = <T extends z.ZodType>(item: T) => z.object({
  page: z.number().int().default(1),
  size: z.number().int().default(20),
  total: z.number().int().nonnegative().default(0),
  items: z.array(item).default([]),
})
